import React from 'react';
import { FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';
import { useNavigate } from 'react-router-dom';
import NuDate from '../../../../Components/Utils/NuDate';
import { GetAccess, GetUseRole } from '../../../../Components/Utils/roles';

const testing = [
  {
    id: 1,
    company: 'Alpha Power Solutions',
    address: 'Dubai, UAE',
    date: '14 Apr 2025',
    type: 'Electrical',
    typeColor: 'bg-yellow-100 text-yellow-700',
  },
  {
    id: 2,
    company: 'Omega Tech Group',
    address: 'Riyadh, KSA',
    date: '15 Apr 2025',
    type: 'Mechanical',
    typeColor: 'bg-blue-100 text-blue-700',
  },
  {
    id: 3,
    company: 'Vertex Industries',
    address: 'Doha, Qatar',
    date: '16 Apr 2025',
    type: 'Control',
    typeColor: 'bg-green-100 text-green-700',
  },
  {
    id: 4,
    company: 'Nexus Engineering',
    address: 'Manama, Bahrain',
    date: '17 Apr 2025',
    type: 'HVAC',
    typeColor: 'bg-purple-100 text-purple-700',
  },
];

function TestingCom() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/upcoming-tc`);
 const navigate = useNavigate();

  const handleNavigate = (id) => {
    navigate(`/testingAndcommisioning/schedules/view/${id}`, {
      state: { fromDashboard: true}
    });
  };

  const handleNavigateEdit = (test) => {
    navigate(`/testingAndcommisioning/schedules/edit/${test.id}`, {
      state: {
        from: "/dashboard",
      },
    });
  };
  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg mb-2">
      <h2 className="text-sm font-bold text-gray-800">Upcoming Testing & Commissioning </h2>
      <p className="text-gray-500 mb-3 text-xs">Scheduled for the next 30 days</p>

      <div className="overflow-y-scroll h-[80%] space-y-3 pr-1 scrollbar-thin scrollbar-thumb-gray-300">
        {data?.map((test) => (
          <div
            key={test.id}
            className="border rounded-xl p-3 flex justify-between items-start bg-white hover:bg-slate-50 transition"
          >
            {/* Company Info */}
            <div className="space-y-1">
              <h3 className="text-xs font-semibold text-gray-700 mb-1">{test.clientName}</h3>
              <p className="text-xs text-gray-500 flex items-center gap-1 mb-1">
                <FaMapMarkerAlt className="text-gray-400" /> {test.location}
              </p>
              <p className="text-xs text-gray-500 flex items-center gap-1">
                <FaCalendarAlt className="text-gray-400" /> {test.date? (
                                       <NuDate
                                         value={test?.date}
                                         format="DD-MMM-YYYY"
                                       />
                                     ) : (
                                       "N/A"
                                     )}
              </p>
            </div>

              <div className="text-right space-y-2">
              <div>
                <span
                  className={`px-2 py-0.5 text-[10px] font-semibold rounded-full ${test.typeColor}`}
                >
                  {test.type}
                </span>
              </div>
              <div className="flex gap-2 justify-end">
                                 {!GetUseRole("client") && GetAccess('inspection_schedule_edit') && (
                
              <button
                  className="px-2 py-1 text-[10px] border border-gray-300 rounded-md text-gray-600 hover:bg-gray-200 transition"
                  onClick={() => handleNavigateEdit(test)}
                >
                  Reschedule
                </button>)}
                {GetAccess('inspection_schedule_edit') &&
                <button
                  className="px-2 py-1 text-[10px] bg-gray-800 text-white rounded-md hover:bg-gray-700 transition"
                  onClick={() => handleNavigate(test.id)}
                >
                  Details
                </button>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TestingCom;
